<template>
  <div>
    <div
        ref="element"
        :style="'position: ' + position + ' ; top :' + top + 'px' +
        ';left :' + left + 'px' + ';right :' + right + 'px' + ';bottom :' + bottom + ';'"
        :class="{'active' : active}"
        class="all-btn-dropdown"
        :key="selfKey"
        @click="getPos()"
    >
      <h-b-dropdown-select
          v-model="dataValue"
          :options="options"
          ref="dropdown"
          @clickCancel="closeByButton = true"
      >
      </h-b-dropdown-select>
    </div>
    <div :class="{'active' : active}" class="block-scroll" @click="handleCancel">

    </div>
  </div>
</template>

<script>
export default {
  name: "static",

  props: {
    value: String,
    options: Array
  },

  data() {
    return {
      dataValue: this.value,
      position: 'relative',
      top: 0,
      left: 0,
      right: 0,
      bottom : 0,
      active: false,
      width : 0 ,
      btnKey : 0,
      selfKey : 0,
      closeByButton : false,
    }
  },

  mounted(){
    this.width = window.innerWidth ;
  },

  methods: {
    getPos() {
      if(!this.closeByButton){
        this.left = this.$refs.element.getBoundingClientRect().left
        this.right = this.$refs.element.getBoundingClientRect().right
        this.bottom = this.$refs.element.getBoundingClientRect().bottom
        this.top = this.$refs.element.getBoundingClientRect().top
        this.right = this.width - this.right ;
        this.position = 'fixed';
        this.active = true;
        document.documentElement.style.overflow = "hidden"
      }
      this.closeByButton = false ;
    },

    handleCancel() {
      this.position = 'relative'
      this.left = 0;
      this.top = 0;
      this.right = 0;
      this.bottom = 0;
      this.active = false;
      document.documentElement.style.overflow = "auto"
      //this.$forceUpdate()
      this.selfKey++ ;
    },

    handleWidth(){
      this.width = window.innerWidth ;
    },
  },

  created () {
    window.addEventListener('resize', this.handleWidth);
  },
  destroyed () {
    window.removeEventListener('resize', this.handleWidth);
  },

  watch: {
    dataValue: function () {
      this.handleCancel() ;
      this.closeByButton = true ;
      this.$emit('input', this.dataValue);
      this.$emit('change') ;
    },

    closeByButton: function () {
      this.handleCancel() ;
    },

    value: function () {
      this.dataValue = this.value;
    }
  }

}
</script>

<style scoped>

.block-scroll.active {
  position: fixed;
  z-index: 1040;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.all-btn-dropdown.active{
  z-index: 1050;
}

.all-btn-dropdown{
  z-index: 1000;
}

</style>